import mysorePalace from "../Images/Home/mysore palace.jpg";
import zoologicalGarden from "../Images/Home/zoological garden.jpg";
import brindavanGardens from "../Images/Home/brindavan gardens.jpg";
import chamundeshwariTemple from "../Images/Home/chamundeshwari temple.jpg";
import KaranjiLake from "../Images/Home/Karanji Lake.jpg";
import StPhilomenaCathedral from "../Images/Home/StPhilomenaCathedral.jpg";
import talakad from "../Images/Home/talakad.jpg";
import chamundiHills from "../Images/Home/chamundi hills.jpg";
import railwayMuseum from "../Images/Home/railway museum.jpg";

const FeaturedDestinations = [
  {
    src: mysorePalace,
    cardTitle: "Mysore Palace",
    cardText: "Lorem ipsum dolor sit amet",
  },
  {
    src: zoologicalGarden,
    cardTitle: "Sri Chamarajendra Zoological Gardens",
    cardText: "Lorem ipsum dolor sit amet",
  },
  {
    src: brindavanGardens,
    cardTitle: "Brindavan Gardens",
    cardText: "Lorem ipsum dolor sit amet",
  },
  {
    src: chamundeshwariTemple,
    cardTitle: "Sri Chamundeshwari Temple",
    cardText: "Lorem ipsum dolor sit amet",
  },
  {
    src: KaranjiLake,
    cardTitle: "Karanji Lake ",
    cardText: "Lorem ipsum dolor sit amet",
  },
  {
    src: StPhilomenaCathedral,
    cardTitle: "St. Philomena's Cathedral",
    cardText: "Lorem ipsum dolor sit amet",
  },
  {
    src: talakad,
    cardTitle: "Talakad",
    cardText: "Lorem ipsum dolor sit amet",
  },
  {
    src: chamundiHills,
    cardTitle: "Chamundi Hills",
    cardText: "Lorem ipsum dolor sit amet",
  },
  {
    src: railwayMuseum,
    cardTitle: "Railway Museum",
    cardText: "Lorem ipsum dolor sit amet",
  },
];
export default FeaturedDestinations;
